import { app } from '../../app';
import { Controller } from './sp-account-status.controller';

app.component('spAccountStatus', {
    bindings: {
        accountStatus: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-account-status.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-account-status/sp-account-status.component.js